import { Member } from '@/src/types/membership';
import { SortableHeader } from '@/src/types/table';
import { CommonModule, CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, input, output, signal, Signal } from '@angular/core';
import { MaterialTableComponent } from '../../shared/material-table/material-table.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '@/src/services/authentication.service';
import { MasterService } from '@/src/services/master.service';
import { PhoneFormatPipe } from '../../../pipes/phone-format-pipe'
import { Constants } from '@/src/helpers/constants';

@Component({
  selector: 'components-member-search',
  standalone: true,
  imports: [MaterialTableComponent, TranslateModule, CommonModule, PhoneFormatPipe],
  templateUrl: './member-search.html',
  styleUrl: './member-search.css',
})
export class MemberSearch {
  open = input<boolean>();
  close = output<void>();
  memberSearch = output<any>();

  param = {
    P_HQ_CD: '',
    P_STR_CD: '',
    P_TEL_NO: ''
  }

  memberHeaders = computed<SortableHeader[]>(() => {
    return [
      { key: 'name', label: 'PAYMESTR0040', sortable: false },
      { key: 'phone', label: 'PAYMESTR0041', sortable: false },
      { key: 'grade', label: 'PAYMESTR0042', sortable: false },
      // { key: 'point', label: 'PAYMESTR0043', sortable: false },
    ];
  });

  data = signal<[]>([])

  constructor(private auth: AuthenticationService, private masterService: MasterService) { }

  P_PAGEROW = Constants.P_PAGEROW_POPUP;

  ngOnInit() {
    this.param.P_HQ_CD = this.auth.getHQCD(),
      this.param.P_STR_CD = this.auth.getStrCd()
    this.getData();
  }

  onClose() {
    this.close.emit();
  }
  onAddToCart(item: any) {
    this.memberSearch.emit(item);
    this.onClose();
  }

  getData() {
    const param = {
      P_HQ_CD: this.param.P_HQ_CD,
      P_STR_CD: this.param.P_STR_CD,
      P_TEL_NO: this.param.P_TEL_NO?.replaceAll('-', '')
    }
    //SP_POP_MEMBER_LIST
    this.masterService.excute_sp('6a8399f1-298d-11f1-9014-00155d001e02', param).subscribe((res: any) => {
      if (res?.isOK) {
        this.data.set(res?.result?.dataRes[0]?.rows);
      }
    })
  }

  onPhoneInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const original = input.value;
    input.value = original.replace(/[eE\+\-]/g, '');
    input.value = input.value.replace(/[^0-9]/g, '');

    if (input.value.length <= 10) {
      input.value = input.value.replace(/(\d{3})(\d{3})(\d{0,4})/, (_, a, b, c) => {
        return c ? `${a}-${b}-${c}` : `${a}-${b}`;
      });
    } else {
      input.value = input.value.substring(0, 11);
      input.value = input.value.replace(/(\d{3})(\d{4})(\d{0,4})/, (_, a, b, c) => {
        return c ? `${a}-${b}-${c}` : `${a}-${b}`;
      });
    }

    this.param.P_TEL_NO = input.value;
  }
}
